import { get, reduce, memoize, assign, find, includes, multiply, add } from 'lodash';

import formData from '../configs/form-data-config';
import calculateTotalWattsNeededWhenWholeHouse from './calculateTotalWattsNeeded';

const allApplianceData = get(formData, 'appliances.fields', []);
const getSelectedApplianceFromData = memoize((key, data, dataKey) => find(data, [dataKey, key]));

const createCalculatedResults = ({ squareFootage, selectedAppliances, selectedFilter, source }) => {
  const appliancesWattageObject = reduce(selectedAppliances, (result, value, key) => {
    const appliance = getSelectedApplianceFromData(key, source, 'label');
    if (!appliance || !includes(appliance.categories, selectedFilter)) {
      return result;
    }
    const applianceWatts = get(appliance, 'watts', 0);
    const applianceWithCalculations = assign({}, appliance, {
      qty: value,
      wattsByQty: multiply(value, applianceWatts),
    });
    // eslint-disable-next-line no-extra-boolean-cast
    const totalWattsFullyUsed = !!appliance.excludeFromPartialUse
      ? add(applianceWithCalculations.wattsByQty, result.totalWattsFullyUsed)
      : result.totalWattsFullyUsed;

    const totalWattsPartiallyUsed = !appliance.excludeFromPartialUse
      ? add(applianceWithCalculations.wattsByQty, result.totalWattsPartiallyUsed)
      : result.totalWattsPartiallyUsed;

    return assign({}, result, {
      items: [
        ...(!appliance.excludeFromPartialUse && [applianceWithCalculations]),
        ...result.items,
      ],
      excludedItems: [
        ...(!!appliance.excludeFromPartialUse && [applianceWithCalculations]),
        ...result.excludedItems,
      ],
      totalWattsPartiallyUsed,
      totalWattsFullyUsed,
    });
  }, {
    items: [],
    excludedItems: [],
    totalWattsPartiallyUsed: 0,
    totalWattsFullyUsed: 0,
    totalWatts: 0,
  });

  return assign({}, appliancesWattageObject, {
    totalWatts: (selectedFilter === 'wholeHouse')
      ? calculateTotalWattsNeededWhenWholeHouse({
        squareFootage,
        partialPoweredApplianceWatts: appliancesWattageObject.totalWattsPartiallyUsed,
        alwaysPoweredApplianceWatts: appliancesWattageObject.totalWattsFullyUsed,
      })
      : add(
        appliancesWattageObject.totalWattsPartiallyUsed,
        appliancesWattageObject.totalWattsFullyUsed,
      ),
  });
};

const calculate = source => ({ sqft, selectedAppliances, selectedFilter }) =>
  createCalculatedResults({
    squareFootage: sqft,
    selectedAppliances,
    selectedFilter,
    source,
  });

export default calculate(allApplianceData);



// WEBPACK FOOTER //
// ./src/views/Home/components/helpers/appliances.js